module.exports = __webpack_public_path__ + "img/wild.5c0f4817.png";